import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

export const FormInput = ({ id, type, name, placeholder, onChange, value, isDisabled, isReadOnly }) => (
  <input
    id={id}
    type={type}
    name={name}
    placeholder={placeholder}
    onChange={onChange}
    value={value}
    disabled={isDisabled || false}
    readOnly={isReadOnly || false}
    className="w-100"
  />
);

FormInput.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
};

export const FormButton = ({ onClick, type, href, name, value, disabled, className, isLoading, textbutton }) => (
  <button
    onClick={onClick}
    type={type}
    href={href}
    name={name}
    value={value}
    disabled={disabled}
    className={`btn w-100 mx-auto ${className || ''}`}
  >
    {isLoading && <LoadingSpinner size={20} />}
    {textbutton}
  </button>
);

FormButton.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  textbutton: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};
